import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getClientes } from "../../redux/actions/actionClient";
import { getDocuments, postDocuments } from "../../redux/actions/actionDocument";
import { getItems } from "../../redux/actions/actionItem";
import { format } from "date-fns";
import Select from "react-select";
import Swal from "sweetalert2";
import {
    customStyles,
    customStylesItems,
    customStylesCoeficiente
  } from "../../Constantes/constantesEstilos";
import DatePicker from "react-datepicker";
import { sumaCantidades, sumaTotalImporte } from "../../utils/sumaCantidades";
import { coeficiente } from "../../utils/coeficientes";
import PresupuestoPdf from "./pdfPresupuesto"

export default function NuevoPresupuesto() {

    let dateAux = new Date();

    const initialForm = {
        quantityItems: [],
        addressEvent: "",
        dateSend: new Date(),
        dateReception: new Date(),
        client_id: "",
        notes: "",
        approved: false,
        subtotal: 0,
        totalCoeficiente: 0,
        coeficiente: "",
        item1:{clave:"", valor:0},
        item2:{clave:"", valor:0}, 
        item3:{clave:"", valor:0}, 
        item4:{clave:"", valor:0},
        totalDocumento: 0,
        subTotalPresupuesto: 0,
    };

    const products = {
        item: "",
        idItem: "",
        name: "",
        descrip: "",
        quantity: "",
        price: 0,
        totalPrice: 0,
        presupuesto: 0,
        totalPricePresupuesto: 0
    }


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const clients = useSelector(state => state.clientes.allClientes);
    const documents = useSelector(state => state.documents.allDocuments);
    const presupuesto = useSelector(state => state.presupuesto.allPresupuesto);
    const items = useSelector(state => state.items.allItems);
    const [form, setForm] = useState(initialForm);
    const [startDate] = useState(new Date());
    const [product, setProduct] = useState(products);
    const [verPDF, setVerPDF] = useState(false);
    const [errors, setErrors] = useState({});
    //const [subtotal, setSubtotal] = useState()

    
    useEffect(() => {
        dispatch(getClientes());        
        dispatch(getDocuments());
        dispatch(getItems())        
    }, [dispatch]);

    
    console.log(clients);
    console.log(documents);
    console.log(presupuesto);
    console.log(items);

    // const newPresupuesto = structuredClone(presupuesto); // se hace una copia del estado global para evitar la referencia
    // console.log(newPresupuesto[0]);


    const codeDocuments = documents[1] + 1; // se crea la numeracion ascendente por numero
    console.log(parseInt(codeDocuments));

    const auxClients = clients.filter((e) => e._id === form.client_id); // se filtra el cliente para mostrar sus datos

    
    const totalArticulos = sumaCantidades(form.quantityItems); // total articulos
    console.log(totalArticulos);
    const importeSubtotal = sumaTotalImporte(form.quantityItems)   
    
    useEffect( () => {
      setForm(prevForm => ({
        ...prevForm,
        subtotal: importeSubtotal 
      }))
    }, [importeSubtotal]);

    const handleTotalDocumento = () => {

    }
    
    
    const handleCoeficiente = (e) => {
      console.log(e.value);
      //console.log(totalImporte);
    let total;

    total = parseFloat(e.value) * parseFloat(importeSubtotal)
    //console.log(parseFloat(totalCoeficiente));    
    setForm({
      ...form,
      //subtotal: totalImporte, 
      totalCoeficiente: total,
      coeficiente: e.value
    })
  }
  
  useEffect(() => {
    setForm(() => ({
      ...form,
      totalCoeficiente: form.coeficiente * form.subtotal
    }))  
  }, [form.coeficiente, form.subtotal]);

  useEffect(() => {
    setForm(() => ({
      ...form,
      totalDocumento: form.totalCoeficiente + parseInt(form.item1.valor) + parseInt(form.item2.valor) + parseInt(form.item3.valor) + parseInt(form.item4.valor)
    }))
  },[form.totalCoeficiente, form.item1.valor, form.item2.valor, form.item3.valor, form.item4.valor]);
  


    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleCliente = (e) => {
        setForm({
            ...form,
            client_id: e.value
        });
    };

    const handleItem = (e) => {
        const auxDescription = items.filter((x) => x._id === e.value);
        console.log(auxDescription);

        setProduct({
            ...product,
            item: e.value,
            name: e.label[2],
            descrip: auxDescription[0].description,
            price: auxDescription[0].value
        });
    };

    const handleDateSend = (date) => {
        setForm({
            ...form,
            dateSend: date
        });
    };

    const handleDateReception = (date) => {
        if (date > form.dateSend) {
            setForm({
              ...form,
              dateReception: date,
            });
          } else {
            Swal.fire(
              "La fecha de recepción no puede ser anterior a la fecha de envío"
            );
          }
    }

    const handleDeleteArt = (e) => {
        // controlador elimina articulo
        //console.log(e.target);
        setForm({
          ...form,
          quantityItems: form.quantityItems.filter(
            (x) => x.item !== e.target.value
          ),
        });
      };

    // const handleApproved = () => {
    //     return setForm({
    //       ...form,
    //       approved: true,
    //     });
    //   };

    const handleQuantity = (e) => {
    //controlador input cantidad
             const { value } = e.target;
        console.log(value);
    
        setProduct({
          ...product,
          [e.target.name]: value,
        });
      };

      const handlePrice = (e) => {
      //controlador input precio  
            const { value } = e.target;
            console.log(value);
            console.log(Number.isInteger(parseInt(value)));
        
            setProduct({
              ...product,
              [e.target.name]: value,
              totalPrice: parseInt(product.quantity) * parseInt(value)
            });            
          };  

      const handleSuma = (e) => {
        const { value } = e.target;
        //console.log(value);
    
        if (e.keyCode === 13) {
          if (product.item === "" || product.quantity === "") {
            Swal.fire("Debe seleccionar artículo y cantidad");
            return;
          }
    
          if (parseInt(product.quantity) === 0) {
            Swal.fire("Debe ingresar un valor mas alto a 0");
            return;
          }
    
          const auxItem = form.quantityItems.find((e) => e.item === product.item);
    
          if (auxItem) {
            Swal.fire("Articulo ingresado");
            return;
          }
    
          const inicio = form.dateSend; //new Date(form.dateSend);
          const fin = form.dateReception; //new Date(form.dateReception);
          // const inicio = new Date("2023-06-01T00:00:00");
          // const fin = new Date("2023-06-30T00:00:00");
          const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
          const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
          const formateadorFecha = new Intl.DateTimeFormat({ dateStyle: "medium" });
          let stockPermitido = false;
          console.log(inicio);
          console.log(fin);
          for (
            let i = inicio;
            i <= fin;
            i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)
          ) {
            //Iteramos de fecha de ingreso a fecha de recepcion por dia
            console.log(i);
            let stockPermitido = false;
            let day = i;
            console.log(day);
    
            const documentsFilter = documents[0].filter(
              (e) =>
                new Date(e.dateReception) >= new Date(day) &&
                new Date(e.dateSend) <= new Date(day)
            ); //filtramos los remitos que esten activos el dia que se esta iterando
            console.log(documentsFilter);
    
            const auxItem = documentsFilter.map((e) =>
              e.quantityItems.find((x) => x.item === product.item)
            ); // filtramos los articulos que ingresamos en el formulario
            console.log(auxItem);
    
            const auxItemFilter = auxItem.filter((e) => e !== undefined);
            console.log(auxItemFilter);
    
            if (auxItemFilter !== undefined) {
              console.log("ok");
              let sumaStock = 0; // recorremos las diferentes cantidades del articulo y las sumamos
              auxItemFilter.forEach(function (x) {
                console.log(x.quantity);
                sumaStock = parseInt(x.quantity) + sumaStock;
              });
              console.log(sumaStock);
    
              const stockItem = items.filter((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
              console.log(stockItem);
    
              const resultadoStock = stockItem[0].stockTotal - sumaStock; // restamos la suma de cantidades al stock total, dandonos por resultado el stock libre por dia
              console.log(resultadoStock);
              console.log(parseInt(product.quantity));
    
              if (parseInt(product.quantity) > resultadoStock) {
                //si la cantidad ingresada es mayor al resultado de stock da verdadero, esto nos indica que no hay stock
    
                Swal.fire(
                  `Acaba de ingresar una cantidad que supera al stock actual. Stock permitido ${resultadoStock}`
                );
                return (stockPermitido = true);
              }
            } else {
              const stockItem = items.find((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
              console.log(stockItem);
    
              if (parseInt(product.quantity) > stockItem.stockTotal) {
                Swal.fire(
                  `Acaba de ingresar una cantidad que supera al stock actual. Stock permitido ${stockItem.stockTotal}`
                );
                return;
              }
    
              console.log("bye");
            }
    
            console.log(formateadorFecha.format(i));
          }
    
          //----
          setForm({
            ...form,
            quantityItems: [...form.quantityItems, product],
          });
          setProduct({
            item: product.item,
            name: product.name,
            descrip: product.descrip,
            quantity: "",
            price: 0,
            totalPrice:0

          });
        }
      };

      const opendPDF = () => {
        setVerPDF(true);
      };

      

      const handleSubmit = (e) => {
        e.preventDefault();
        console.log(form);
    
        if (
          form.numberDocument === "" ||
          !form.quantityItems.length ||
          form.addressEvent === "" ||
          form.dateSend === "" ||
          form.dateReception === "" ||
          form.client_id === ""
        ) {
          return Swal.fire("Hay campos sin completar");
        } else if (
          form.totalCoeficiente === ""
        ) {
          return Swal.fire("Debe completar un coeficiente");
        }
    
        // Swal.fire({
        //   title: "¿Aprueba el pedido actual?",
        //   showDenyButton: true,
        //   confirmButtonText: "Si",
        //   denyButtonText: "No",
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     dispatch(postPresupuesto({ ...form, approved: true, subtotal: totalImporte })); //recurso que deja actualizar una propiedad sin tocar el estado
    
        //     setForm({
        //       numberDocument: "",
        //       quantityItems: [],
        //       addressEvent: "",
        //       dateSend: "",
        //       dateReception: "",
        //       descriptions: "",
        //       //user_id: "",
        //       client_id: "",
        //       notes: "",
        //       approved: false,
        //     });
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, "300");
        //   } else if (result.isDenied) {
            dispatch(postDocuments(form));
    
            setForm({
              numberDocument: "",
              quantityItems: [],
              addressEvent: "",
              dateSend: "",
              dateReception: "",
              descriptions: "",
              //user_id: "",
              client_id: "",
              notes: "",
              approved: false,
              item1:{clave:"", valor:0},
              item2:{clave:"", valor:0}, 
              item3:{clave:"", valor:0}, 
              item4:{clave:"", valor:0},
              totalDocumento: 0,
              subTotalPresupuesto: 0,              
            });

            setProduct({
              item: "",
              name: "",
              descrip: "", 
              quantity: "",
              price:0,
              toalPrice:0        
            });
            setTimeout(() => {
              navigate('/presupuestos')      
            }, 300);
        //   }
        // });
      };

      const handleAgregados = (e, clave, valor) => {
        const { value } = e.target;
        const { name } = e.target;
        // console.log("Nombre", name);
        // console.log("Valor", value);
        const nameSplit = name.split("."); // separamos el nombre del input para obtener la clave y el valor
        //console.log("nameSplit", nameSplit);
        const itemKey = nameSplit[0]; // obtenemos la clave del objeto
        //console.log(itemKey);
        
        
        //if(nameSplit[1] === "clave"){
          setForm({
            ...form,
            [itemKey]: { ...form[itemKey], [nameSplit[1]]: value}
          });
        //}
      }

    return (
        <div className="container bg-gray-900">
            <div className="m-8 text-orange-500 font-bold">
                <div>
                    <p className="text-xl pb-4">Presupuesto - Nuevo</p>
                </div>
                <div className="flex flex-row justify-between text-[10pt] border-b-2 border-slate-500">
          <div className="">
            Fecha: {dateAux ? format(dateAux, "dd/MM/yyyy") : null}
          </div>
          <div>
            <label className="">N° Documento: </label>
            <input
              className="w-28 bg-slate-700 pl-3"
              type="text"
              name="numberDocument"
              placeholder=""
              onChange={handleChange}
              value={"0" + "" + codeDocuments}
              requerid="true"
            />
          </div>
        </div>

        <div className="border-b-2 border-slate-500 py-2">
          <div className="flex flex-row">
            <div className="text-[10pt]">
              <label>Cliente</label>
            </div>
            <div className="ml-2 font-bold pb-1">
              <Select
                styles={customStyles}
                placeholder="Clientes"
                options={clients.map((e) => ({ label: e.nameCompany, value: e._id }))}
                onChange={handleCliente}
              />
              {errors.client_id && (
                <p className="text-red-900">{errors.client_id}</p>
              )}
            </div>
          </div>
          <div className="w-full">
            {form.client_id === "" ? (
              <div className="flex flex-row flex-wrap text-[10pt]">
                <div className="w-1/3">Compañia: </div>
                <div className="w-1/3">Nombre: </div>
                <div className="w-1/3">Apellido: </div>
                <div className="w-1/3">Direccion: </div>
                <div className="w-1/3">Telefonos: </div>
                <div className="w-1/3">Email: </div>
              </div>
            ) : (
              <div className="w-full">
                {auxClients.map((e) => {
                  return (
                    <div
                      key={e._id}
                      className="flex flex-row flex-wrap text-[10pt]"
                    >
                      <div className="w-1/3">Compañia: {e.nameCompany}</div>
                      <div className="w-1/3">Nombre: {e.name}</div>
                      <div className="w-1/3">Apellido: {e.lastName}</div>
                      <div className="w-1/3">Direccion: {e.address}</div>
                      <div className="w-1/3">
                        Telefonos: {e.telephoneNumber}
                      </div>
                      <div className="w-1/3">Email: {e.email}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="border-b-2 border-slate-500">
          <div className="flex flex-row pt-2 text-[10pt] w-full">
            <div className="w-1/3">
              <label>Domicilio de Evento</label>
              <input
                className="ml-2 border rounded w-2/3 bg-slate-700"
                type="text"
                name="addressEvent"
                onChange={handleChange}
                value={form.addressEvent}
              />
              {errors.addressEvent && (
                <p className="text-red-900">{errors.addressEvent}</p>
              )}
            </div>
            <div className=" flex w-56">
              <label className="w-40">Fecha de envío</label>
              <DatePicker
                className="w-24 pl-3 ml-2 rounded bg-slate-700"
                selected={startDate}
                onChange={handleDateSend}
                value={
                  form.dateSend ? format(form.dateSend, "dd/MM/yyyy") : null
                }
              />
            </div>
            <div className="flex w-56">
              <label className="w-68">Fecha de Recepción</label>
              <DatePicker
                className="w-24 pl-3 ml-2 rounded bg-slate-700"
                selected={startDate}
                onChange={handleDateReception}
                value={
                  form.dateReception
                    ? format(form.dateReception, "dd/MM/yyyy")
                    : null
                }
              />
            </div>
          </div>
          <div className="pt-2 pb-2 text-[10pt]">
            <label className="mr-4">Notas</label>
            <input
              className="border rounded w-1/2 h-6 bg-slate-700"
              type="text"
              name="notes"
              onChange={handleChange}
              value={form.notes}
            />
          </div>
        </div>

        <div className="flex flex-row w-full">
          <label className="w-1/3 text-[10pt] pl-20">
            Seleccionar Articulos
          </label>
          <label className="w-36 text-[10pt] pl-10">Cantidad</label>
          <label className="w-36 text-[10pt] pl-10">Precio</label>
        </div>
        <div className="flex flex-row w-full">
          <div className="w-1/3 font-bold text-orange-500">
            <Select
              options={items.map((e) => ({
                label: [e.idItem, "- ", e.name, " - ", e.description],
                value: e._id,
              }))}
              styles={customStylesItems}
              placeholder="Artículos"
              onChange={handleItem}
            />
          </div>
          <div className="w-36 h-5 pl-5">
            <input
              className="border rounded w-24 h-5 pt-2 bg-slate-700"
              type="text"
              name="quantity"
              //onKeyDown={keyPres}
              onChange={handleQuantity}
              //onKeyUp={handleSuma}
              //onBlur={handleBlurQuantity}
              value={product.quantity}
            />
          </div>
          <div className="w-36 h-5 pl-5">
            <input
              className="border rounded w-24 h-5 pt-2 bg-slate-700"
              type="text"
              name="price"
              //onKeyDown={keyPres}
              onChange={handlePrice}
              onKeyUp={handleSuma}
              //onBlur={handleBlurQuantity}
              value={product.price}
            />
          </div>
        </div>

        <div className="pt-4">
          <div className="flex flex-row text-[12pt] font-bold min-w-full border-b-2 border-white">
            <div className="w-[250px]">Articulo</div>
            <div className="w-[552px]">Descripcion</div>
            <div className="w-20 text-center">Cantidad</div>
            <div className="w-20">Precio U.</div>
            <div className="w-16">Importe</div>
          </div>
          <div className="min-w-full">
            {form.quantityItems.map((e, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-row text-[10pt] border-b-2 border-slate-500"
                >
                  <div className="w-[250px]">{e.name}</div>
                  <div className="w-[552px]">{e.descrip}</div>
                  <div className="w-20 text-center">
                    {e.quantity}
                  </div>
                  <div class="w-20 text-center">
                    {e.price}
                  </div>
                  <div class="w-16 text-center">
                    {e.totalPrice}
                  </div>
                  <button
                    value={e.item}
                    onClick={handleDeleteArt}
                    className="w-10 ml-1 bg-red-500 hover:bg-red-600 text-white font-bold"
                  >
                    X
                  </button>
                </div>
              );
            })}
          </div>
          <div className="flex flex-row text-[10pt] font-bold mt-5 border-b-2 border-slate-300">
            <div className="w-[802px]">Subtotal</div>
            <div className="w-20 text-center">{totalArticulos}</div>
            <div className="w-20"></div>
            <div className="w-16 text-center">{importeSubtotal}</div>                  
          </div>
        </div>
        <div className="flex flex-row mt-10 border-b-2 border-white">
          <p className="w-24">Coeficiente</p>
          <div className="w-28 pt-[2px]">
          <Select
                styles={customStylesCoeficiente}
                placeholder=""
                options={coeficiente.map((e) => ({ label: [e.dias, " -> ", e.valor], value: e.valor }))}
                onChange={handleCoeficiente}
              />
          </div>
              <p className="w-[350px]"></p>
              <p className="w-36">
                Total Coeficiente:
              </p>
              <p className="w-32">
                {form.totalCoeficiente}
              </p>
        </div>
        <div className="mt-4">
          <div className="flex">
            <p className="mr-2">Item 1</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item1.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item1.valor" value={form.item1.valor} onChange={handleAgregados}/>
          </div>
          <div className="flex">
            <p className="mr-2">Item 2</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item2.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item2.valor" value={form.item2.valor} onChange={handleAgregados}/>
          </div>
          <div className="flex">
            <p className="mr-2">Item 3</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item3.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item3.valor" value={form.item3.valor} onChange={handleAgregados}/>
          </div>
          <div className="flex">
            <p className="mr-2">Item 4</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item4.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item4.valor" value={form.item4.valor} onChange={handleAgregados}/>
          </div>
        </div>
        <div className="flex mt-5">
          <p className="mr-4">Total:</p>
          <p>{form.totalDocumento}</p>
        </div>

        <div className="flex flex-row justify-around w-1/3">
          <div>
            <button
              className="mt-12 p-4 rounded bg-sky-500 text-white hover:text-black"
              onClick={handleSubmit}
            >
              Guardar
            </button>
          </div>
          <div>
            <button
              className="mt-12 p-4 rounded bg-sky-500 text-white hover:text-black"
              onClick={opendPDF}
            >
              Ver PDF
            </button>
          </div>
        </div>
          <div>
          {verPDF ? (
            <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center"
            >
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button
                  className="text-black font-bold hover:text-white"
                  onClick={() => setVerPDF(false)}
                >
                  Cerrar
                </button>
              </div>
              <div>
                <PresupuestoPdf />
              </div>
            </div>
          ) : null}
        </div>

            </div>
        </div>
    )
}